import { Button } from '~src/components/Button';
import { Heading } from '~src/components/Typography';

import { Mask, MaskLabelWrapper, MaskWrapper, Row } from '../style';
import { GoogleMapProps } from '../types';

export const MapOverlay = ({
  disabled,
  setDisabled,
  height,
  children,
  markerAdjusted,
}: Pick<GoogleMapProps, 'disabled' | 'setDisabled' | 'height' | 'children' | 'markerAdjusted'>) => (
  <MaskWrapper {...{ disabled, height }}>
    {children}

    <Mask {...{ height, disabled }} />

    <MaskLabelWrapper {...{ disabled }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {!markerAdjusted && (
          <Heading color='light' level={2}>
            Vi har placeret en markør, hvor vi tror dit hus er.
          </Heading>
        )}

        <Row>
          <Heading color='light' level={3}>
            Er dette ikke dit hus?
          </Heading>

          <Button type='callToAction' size='small' style={{ marginLeft: '8px' }} onClick={() => setDisabled?.(false)}>
            Skift placering
          </Button>
        </Row>
      </div>
    </MaskLabelWrapper>
  </MaskWrapper>
);
